import canOverrideBonus from './canOverrideBonus';

// User-facing labels for each period status (see BonusPeriodStatusCard /
// the Approvals screen). Raw status strings are never shown to users.
export const PERIOD_STATUS_LABELS: Record<BonusTypes.PeriodStatus, string> = {
  active: 'Active',
  'in review': 'Finalizing Data',
  'pending sign off': 'Review and Approve',
  closed: 'Closed',
  archived: 'Archived',
};

/**
 * Why overrides can't be applied to the current selection, or undefined when
 * they can. See canOverrideBonus: sub-period programmes allow overrides once
 * the selected week has elapsed; ordinary programmes only when the period is
 * "pending sign off".
 */
const getOverrideDisabledMessage = ({
  selectedBonusPeriod,
  selectedSubPeriod,
}: {
  selectedBonusPeriod: BonusTypes.BonusPeriod;
  selectedSubPeriod?: Period;
}): string | undefined => {
  if (canOverrideBonus({ selectedBonusPeriod, selectedSubPeriod })) {
    return undefined;
  }
  if (selectedSubPeriod) {
    return `"${selectedSubPeriod.label}" hasn't finished yet. Overrides can be applied once the week has ended.`;
  }
  return `The period is currently "${PERIOD_STATUS_LABELS[selectedBonusPeriod.status]}". Overrides can only be applied when the period is "Review and Approve".`;
};

export default getOverrideDisabledMessage;
